import {createAllActions, createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'FEED/DRAFTS';

// Simple actions with no additional success/failed behavior use createAction
export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {action: showDraftSelector} = createAction(`${domain}/SHOW_DRAFT_SELECTOR`, (show: boolean) => ({show}));

export const {action: showObservationForm} = createAction(`${domain}/SHOW_OBSERVATION_FORM`, (show: boolean) => ({
    show,
}));

// For actions that require separate payload creators for success or failure,
// use createAllActions. (Note: The aborted action creator uses the default fallback.)
export const {
    action: selectDraft,
    success: selectDraftSuccess,
    failed: selectDraftFailed,
} = createAllActions(
    `${domain}/SELECT_DRAFT`,
    (payload: {form: any; draft: any; draftIsDirty: boolean; canUseRichTextInPosts?: boolean}) => payload,
    (payload: {draftId: string; showObservationForm: boolean; variant: any}) => payload,
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAllActions(
    `${domain}/UPDATE`,
    (payload: {
        draftId: string;
        recipients: any;
        from: any;
        body: string;
        richTextBody: string;
        files: any;
        observationData: any;
        disableFeedback: boolean;
        activities: any;
        famlyLiveMeetingId: any;
        pollId: any;
    }) => ({...payload, send: false}),
    (payload: {oldDraftId: string; newDraft: any}) => payload,
    (payload: {draft: any}) => payload,
);

export const {
    action: updatePost,
    success: updatePostSuccess,
    failed: updatePostFailed,
} = createAllActions(
    `${domain}/UPDATE_POST`,
    (payload: {
        postId: string;
        body: string;
        richTextBody: string;
        formIdentifier: string;
        recipients: any;
        from: any;
        files: any;
        observationData: any;
        disableFeedback: boolean;
        reNotify: boolean;
        activities: any;
        famlyLiveMeetingId: any;
        pollId: any;
    }) => payload,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    () => {},
);

export const {
    action: send,
    success: sendSuccess,
    failed: sendFailed,
} = createAllActions(
    `${domain}/SEND`,
    (payload: {
        draftId: string;
        recipients: any;
        from: any;
        body: string;
        richTextBody: string;
        files: any;
        formIdentifier: string;
        observationData: any;
        disableFeedback: boolean;
        activities: any;
        famlyLiveMeetingId: any;
        facebookPageIds: any;
        rssInstitutionSetIds: any;
        overridePostBlock: any;
        sendAsSms: boolean;
        pollId: any;
    }) => ({...payload, send: true}),
    (payload: {draftId: string; famlyLiveMeetingId: any}) => payload,
    (draftId: string) => ({draftId}),
);

export const {action: sendAborted} = createAction(`${domain}/SEND_ABORTED`, (draftId: string) => ({draftId}));

export const {
    action: clearDraft,
    success: clearDraftSuccess,
    failed: clearDraftFailed,
} = createAllActions(
    `${domain}/CLEAR_DRAFT`,
    (payload: {showObservationForm: boolean; form: string; draftIsDirty: boolean}) => payload,
    (showObservationForm: boolean) => ({showObservationForm}),
);

export const {action: newPostFormDidChange} = createAction(
    `${domain}/NEW_POST_FORM_DID_CHANGE`,
    (formName: string) => ({formName}),
);

export const {action: createOrUpdate, failed: createOrUpdateFailed} = createAction(
    `${domain}/CREATE_OR_UPDATE`,
    (formName: string) => ({formName}),
);

export const {action: closeDraftManagerModal} = createAction(`${domain}/CLOSE_DRAFT_MANAGER_MODAL`, () => ({}));
